const RAG = 'RAG';
const Name = 'Name';
const Postcode = 'Postcode';
const Grade = 'Grade';
const Duration = 'Duration';
const options = [RAG, Name, Postcode, Grade, Duration];

export { RAG, Name, Postcode, Grade, Duration, options };
